import { jsx as t } from "react/jsx-runtime";
import { c as i } from "../index-rKuIKazb.js";
import n from "./ImgHeroRegular/index.js";
import f from "./ImgHeroReverse/index.js";
import u from "./ImgHeroEmerald/index.js";
import d from "./ImgHeroPicton/index.js";
import '../assets/index19.css';const p = "_layout_1f2na_2", g = {
  layout: p
}, I = {
  default: void 0,
  emerald: u,
  picton: d
}, _ = (o) => {
  const { className: r, fixed: a, reverse: m, size: s, theme: c = "default" } = o, l = (() => {
    const e = I[c];
    return e || (m ? f : n);
  })();
  return /* @__PURE__ */ t("picture", { className: i(g.layout, r), children: /* @__PURE__ */ t(l, { fixed: a, size: s }) });
};
export {
  _ as default
};
